/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISharepointUpdate
 */
export interface APISharepointUpdate {
    /**
     * 
     * @type {string}
     * @memberof APISharepointUpdate
     */
    readonly self: string;
    /**
     * 
     * @type {number}
     * @memberof APISharepointUpdate
     */
    shareDuration: number;
}

/**
 * Check if a given object implements the APISharepointUpdate interface.
 */
export function instanceOfAPISharepointUpdate(value: object): value is APISharepointUpdate {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('shareDuration' in value) || value['shareDuration'] === undefined) return false;
    return true;
}

export function APISharepointUpdateFromJSON(json: any): APISharepointUpdate {
    return APISharepointUpdateFromJSONTyped(json, false);
}

export function APISharepointUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISharepointUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'shareDuration': json['share_duration'],
    };
}

export function APISharepointUpdateToJSON(value?: Omit<APISharepointUpdate, 'self'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'share_duration': value['shareDuration'],
    };
}

